import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  path?: string;
}

const defaults = {
  title: "Speshly — Never Miss a Moment That Matters",
  description:
    "Speshly automatically sends heartfelt cards and curates perfect gifts for every special occasion — birthdays, anniversaries, holidays — all on autopilot.",
  base: "https://speshly.danch.au",
};

const SEO = ({ title, description, path = "/" }: SEOProps) => {
  const fullTitle = title ? `${title} | Speshly` : defaults.title;
  const desc = description || defaults.description;
  const url = `${defaults.base}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};

export default SEO;
